import { Box, Button, Chip, Divider, Drawer, IconButton, List, Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import RenderInputField from "components/Reports/ReusableComponents/RenderInputField/RenderInputField";
import { ClearRounded, FilterAltRounded, KeyboardArrowRightRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { getColumnValue } from "components/Reports/data";
const drawerWidth = 240;

const FilterDrawer = ({ drawerOpen, setDrawerOpen, filter, setFilter, columns, drawerPosition, children }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	// const [drawerList, setDrawerList] = useSearchParams();
	const drawerList = columns?.reduce((acc, row) => {
		if (row?.display) acc = [...acc, row];
		return acc;
	}, []);
	// const setUrlParams = (column, value) => {
	// 	let obj = { ...searchParams };
	// 	setDrawerElements(
	// 		Object.keys(drawerList)?.reduce((acc, row) => {
	// 			if (drawerList[row].display) acc = [...acc, drawerList[row]];
	// 			return acc;
	// 		}, [])
	// 	);

	// 	obj[column.key] = value;
	// 	setSearchParams((searchParams) => {
	// 		searchParams.set(column.key, value);
	// 		return searchParams;
	// 	});
	// 	setTab(value);
	// };
	const handleFilterDrawerOpen = () => {
		setDrawerOpen(true);
	};
	const handleFilterDrawerClose = () => {
		setDrawerOpen(false);
	};
	return (
		<Box display="flex" columnGap={1} alignItems="center">
			<Box display="flex" columnGap={1} flexWrap="wrap" rowGap={"5px"} flexGrow={1}>
				{!Object.keys(filter).length && (
					<Typography variant="body1" fontSize={16} color={grey[700]}>
						No Filters Applied
					</Typography>
				)}
				{columns
					?.reduce((acc, row) => {
						if (filter[row.key])
							acc.push(
								<Chip
									sx={{ textTransform: "capitalize" }}
									label={`${row?.name.toLowerCase()} : ${getColumnValue(row, filter)}`}
									size="small"
								/>
							);
						return acc;
					}, [])
					.map((chip) => chip)}
			</Box>
			<Button
				onClick={handleFilterDrawerOpen}
				startIcon={<FilterAltRounded />}
				variant="contained"
				size="medium"
				sx={{ textTransform: "capitalize" }}>
				Filter
			</Button>
			<Drawer
				// variant="temporary"
				anchor="right"
				open={drawerOpen}
				onClose={() => setDrawerOpen(!drawerOpen)}>
				<Stack width={drawerWidth} p={2} spacing={1}>
					<Box pt={8} display="flex" alignItems="center" columnGap={1}>
						<IconButton sx={{ background: grey[100] }} size="small" onClick={handleFilterDrawerClose}>
							<ClearRounded sx={{ transform: "scale(1)" }} />
						</IconButton>
						<Typography variant="h6"> Apply Filter</Typography>
					</Box>
					<Divider />
					{!children
						? columns?.map((col) => {
								return (
									<RenderInputField
										column={col}
										data={filter}
										setData={setFilter}
										selectOptObjName={"select_options"}
										width={"100%"}
										longWidth={"100%"}
										disabled={false}
										// disableLabel={true}
									/>
								);
						  })
						: children}
				</Stack>
			</Drawer>
		</Box>
	);
};

export default FilterDrawer;
